import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileSignature } from '@fortawesome/free-solid-svg-icons'

import { RouteInfoType } from "../../types/types";

import GeneralSettingsLayout from "./GeneralSettingsLayout"
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import AccountPage from './pages/AccountPage';
import TariffPage from './pages/TariffPage';
import PaymentsHistoryPage from './pages/PaymentsHistoryPage';


const generalSettings = [{
    id: "settings",
    name: "Настройки",
    path: "/settings",
    icon: <FontAwesomeIcon icon={faFileSignature as IconProp} size={"lg"}/>,
    component: GeneralSettingsLayout,
    header: "Общие настройки",
    nonCollapsable: true,
    routes: [
        {
            path: '/settings/tariff',
            name: 'Тариф',
            component: TariffPage,
        },
        {
            path: '/settings/payment-history',
            name: 'История оплат',
            component: PaymentsHistoryPage,
        },
        {
            path: '/settings/account',
            name: 'Аккаунт',
            component: AccountPage
        }
    ]
}]

export default generalSettings as RouteInfoType[];
